@use '@lib/assets/styles/main.scss' as *;

%bordered {
  &:not(:first-child) {
    border-left: 1px solid $gray100;
  }
}

.body {
  position: relative;
  z-index: 0;

  & td {
    border-top: 1px solid $gray100;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
    box-sizing: border-box;
    &.borderedCell {
      @extend %bordered;
    }
  }

  &.tableWithBorderedCells  {
    td {
      @extend %bordered;
    }
  }
}

tr {
  &:not(.trSelected) {
    background: $gray0;
  }
  &.trSelected {
    background: $gray10;
  }
  &.trClickable {
    position: relative;
    transition: background-color 0.2s ease;
    &:hover {
      background: $gray10;
    }
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      cursor: pointer;
    }
  }
}

.tdContent {
  padding: 10px 8px;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: start;
  .tableWithBorderedCells & {
    padding: 10px 16px;
  }
  & > * {
    word-break: break-word;
    max-width: 100%;
  }

  td:first-child:not(.selectCell) & {
    padding-left: 24px;
  }

  .selectCell + td > & {
    padding: 10px 8px;
  }
  .selectCell & {
    padding: 0 0 0 4px;
  }
}

.tdContentCenter {
  justify-content: center;
}

.tdContentEnd {
  justify-content: end;
}

.tdContentDisabled {
  @extend %disabledGrayscale;
}

.selectCell {
  min-width: 52px;
  width: 1%;
  & > label {
    vertical-align: middle;
    display: flex;
  }
}
